import { render, staticRenderFns } from "./RepairBig.vue?vue&type=template&id=ff2370d0"
import script from "./RepairBig.vue?vue&type=script&lang=js"
export * from "./RepairBig.vue?vue&type=script&lang=js"
import style0 from "./RepairBig.vue?vue&type=style&index=0&id=ff2370d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports